export default __webpack_public_path__ + "static/media/trr-drink-beer-bluemoon.0bde26fb.png";